import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL || '';




const getAllReads = async () => {
    const token = localStorage.getItem('token');

    const response = await axios.get(`https://www.kipmate.com/sortyourkip/api/media/getreads`, {
        headers: {
            Authorization: `${token}` // Include the token in the Authorization header
        },
    });

    // console.log(response.data)

    return response.data
}





// const getAllReads = async () => {
//
//     const token = localStorage.getItem('token');
//
//     console.log("readservice here with token:", token)
//
//     const response = await axios.post(`https://www.kipmate.com/sortyourkip/api/media/getreads`, {
//         token: token
//     });
//
//     return response.data
// }





const readService = { getAllReads }

export default readService;
